module.exports = __webpack_public_path__ + "static/sport/img-swiper1.6809229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/img-swiper1.png
// module id = 8zSu
// module chunks = 0